/**
 *  Locations constant module file
**/

export const MODULE_NAME = 'locations'

export const ACTIONS = {
  FETCH_SHOPS: 'fetchShops',
  FETCH_ADVERTS: 'fetchAdverts',
  FETCH_POIS: 'fetchPOIs',
  FETCH_ZONES: 'fetchZones',
  FETCH_GRIDS: 'fetchGrids'
}

export const MUTATIONS = {
  CLEAR_LOCATIONS: 'clearLocations',
  SET_LOADING: 'setLoading',
  TOGGLE_VIEWPORT_FILTER: 'toggleViewportFilter',
  SET_VIEWPORT_DATA: 'setViewportData',
  SET_LOCATIONS: 'setLocations'
}

export const GETTERS = {
}
